import { assistanceApi } from '@shared/travel-assistance/assistance.api';
import { bookingApi } from '@booking/booking.api';
import { hotelDetailApi } from '@hotels/hotel-detail/hotel-detail.api';
import { searchBarApi } from '@search-bar/search-bar.api';
import { billingApi } from '@billing/billing.api';
import { paxApi } from '@pax/pax.api';
import { topZonesApi } from '@app/modules/core/api/top-zones.api';
import { userHistoryApi } from '@user-history/user-history.api';
import { authSeamlessLoginApi, seamlessLoginApi, userAddressesApi, userApi } from '@app/modules/core/api/user.api';
import { homeApi } from '@home/home.api';
import { upsellApi } from '@app/modules/upsell/upsell.api';
import { abandonedReservationApi } from '@abandoned-reservation/api/abandoned-reservation.api';
import { recentApi } from '@recent-searches/recent.api';
import { widgetsApi } from '@shared/widgets/widgets.api';
import { flightResultsApi } from '@flight-results/flight-results.api';
import { hotelResultsApi } from '@hotels/hotel-results/hotel-results.api';
import { activitiesApi } from '@activities/api/activities.api';
import { autoApi } from '@autos/auto.api';
import { packagesResultApi } from '@packages/packages-result/packages-result.api';

export const apiExceptions = [
  userApi.data.url,
  userApi.info.url,
  userApi.get_benefits.url,
  userApi.statics_lists.url,
  homeApi.home_data,
  abandonedReservationApi.retarget.get_retarget,
  topZonesApi.data.url,
  searchBarApi.ip_public.url,
  searchBarApi.ubication_ip.url,
  searchBarApi.hotel_search_destination.url,
  searchBarApi.travel_extra_search.url,
  hotelResultsApi.hotel_search,
  hotelResultsApi.hotel_results,
  hotelResultsApi.hotel_search_byhours,
  hotelDetailApi.hotel_deeplink,
  hotelDetailApi.hotel_byhours_deeplink,
  flightResultsApi.air_search,
  flightResultsApi.air_search_by_sector,
  flightResultsApi.air_flex_dates,
  packagesResultApi.package_search,
  packagesResultApi.package_hotel_results,
  autoApi.auto_search,
  autoApi.auto_results,
  autoApi.auto_filter,
  autoApi.auto_detail,
  upsellApi.air_upsell_by_sector,
  upsellApi.air_upsell,
  bookingApi.air_validation,
  bookingApi.air_validation_by_sector,
  bookingApi.hotel_validation,
  bookingApi.hotel_validation_byhours,
  bookingApi.package_validate,
  bookingApi.auto_validation,
  bookingApi.activities_validate,
  bookingApi.air_book,
  bookingApi.air_book_by_sector,
  bookingApi.hotel_book,
  bookingApi.package_book,
  bookingApi.auto_book,
  bookingApi.activities_book,
  bookingApi.rappi_payment,
  bookingApi.rappi_intermediary_payment,
  paxApi.document.pax_document_create,
  paxApi.loyalty.loyalty_token,
  paxApi.loyalty.marriott_loyalty_number,
  paxApi.loyalty.create_marriott_bonvoy_account,
  paxApi.pax_create,
  paxApi.pax_update,
  billingApi.default_billing,
  billingApi.create_billing,
  assistanceApi.assistance_search,
  userHistoryApi.air_policies,
  userHistoryApi.air_exchange_book,
  userHistoryApi.history_detail.get_detail_by_validate,
  activitiesApi.search,
  seamlessLoginApi.auth_user.url,
  recentApi.home_searches_recent,
];

export const apiUsesRappiToken = [
  authSeamlessLoginApi.url,
  userApi.info.url,
  userAddressesApi.data.url,
  recentApi.home_searches_recent,
  widgetsApi.alerts.get_user_alerts,
  userHistoryApi.userhistory,
  homeApi.home_data,
  paxApi.pax_traveler_list,
  billingApi.create_billing,
  bookingApi.rappi_payment,
  bookingApi.rappi_intermediary_payment,
  userHistoryApi.history_detail.last,
  userHistoryApi.history_detail.get_detail_by_validate,
  userHistoryApi.history_detail.validate_payment_itinerary,
  userHistoryApi.userTravelEta,
  userHistoryApi.cancellation,
  billingApi.travel_order_billing.create_order_billing
];
